import { render, staticRenderFns } from "./SalesRepresentativeAllocation.vue?vue&type=template&id=1715eb22&scoped=true&"
import script from "./SalesRepresentativeAllocation.vue?vue&type=script&lang=js&"
export * from "./SalesRepresentativeAllocation.vue?vue&type=script&lang=js&"
import style0 from "./SalesRepresentativeAllocation.vue?vue&type=style&index=0&id=1715eb22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1715eb22",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDialog,VForm,VIcon,VSelect,VTextField})
